// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mt-0";
export var leftAlign = "_mt-4";
export var listItem = "_mt-2";
export var listItemWrapper = "_mt-1";
export var operationText = "_mt-3";